import styled from 'styled-components';

const Overlay = styled.div`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: fixed;
  top: ${({ offset }) => (offset ? `${offset}px` : '0')};
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ color }) => color || '#2d2d2d'};
  opacity: ${({ opacity }) => opacity || '0.2'};
  z-index: ${({ zIndex }) => zIndex || '10'};

  ${({ width }) => (width ? `width: ${width}` : '')};
  ${({ height }) => (height ? `height: ${height}` : '')};
`;

export default Overlay;
